import { IonContent, IonPage, IonButton, IonHeader,
  IonGrid, IonRow, IonCol, IonToolbar, IonIcon, 
  IonText, IonSelectOption, IonItem, IonLabel,
  IonSlides, IonSlide, IonButtons, IonTextarea, IonToast,
  IonInput, IonSelect, useIonViewDidEnter } from '@ionic/react';
import { useHistory } from "react-router-dom";
import { remove, get, set } from '../../services/storage.service';
import { RouteComponentProps} from "react-router-dom";
import FooterComponent from "../../components/FooterComponent";
import LoginCheck from "../../components/LoginCheck";


import { logOutOutline, chevronBackOutline, openOutline, trashOutline } from 'ionicons/icons';
import './CreateExploration.css';
import React,{useState,useRef} from 'react';

function saveToStorage(saveproject:any,savetitle:any,savedescription:any,savecolor:any) {
  if (saveproject) {    
    set(saveproject, JSON.stringify({ "Title": savetitle, "Description": savedescription, "color": savecolor}))
  return true;
  }
  return false;
}
interface ResetProps
    extends RouteComponentProps<{
        id: string;
    }> { }
  interface LocationError {
      showError: boolean;
      message?: string;
  }
const CreateExploration: React.FC<ResetProps> = ({ match }) => {

  useIonViewDidEnter(() => {
    get("project1")
     .then(function (finalResult) { //get the user data to authenticate the user
        const userD = JSON.parse(finalResult);
        if(finalResult !== null){
          enablefields1(false);
          setproj1color(userD.color);
          setproj1name(userD.Title);
          setdesc1(userD.Description);
          //setLabel1("Open");
        }
     }).catch(err => {//unable to load the local storage
         console.log("e: " + err.message);
     });
     get("project2")
     .then(function (finalResult) { //get the user data to authenticate the user
        const userD = JSON.parse(finalResult);
        if(finalResult !== null){
          enablefields2(false);
          setproj2color(userD.color);
          setproj2name(userD.Title);
          setdesc2(userD.Description);
          //setLabel2("Open");
        }
     }).catch(err => {//unable to load the local storage
         console.log("e: " + err.message);
     });
     get("project3")
     .then(function (finalResult) { //get the user data to authenticate the user
        const userD = JSON.parse(finalResult);
        if(finalResult !== null){
          enablefields3(false);
          setproj3color(userD.color);
          setproj3name(userD.Title);
          setdesc3(userD.Description);
          //setLabel3("Open");
        }
     }).catch(err => {//unable to load the local storage
         console.log("e: " + err.message);
     });
     console.log("pageloaded");
   });

    const history = useHistory();

    const [swiper, setSwiper] = useState<any>({});
    //const [currentcheck, setCurrent] = useState<any>('0');
    const [color1, setproj1color] = useState<string>('blue');
    const [color2, setproj2color] = useState<string>('blue');
    const [color3, setproj3color] = useState<string>('blue');
    const [project1, setproj1name] = useState<string>('');
    const [project2, setproj2name] = useState<string>('');
    const [project3, setproj3name] = useState<string>('');
    const [description1, setdesc1] = useState<string>('');
    const [description2, setdesc2] = useState<string>('');
    const [description3, setdesc3] = useState<string>('');
    const [fields1,enablefields1] = useState<boolean>(true);
    const [fields2,enablefields2] = useState<boolean>(true);
    const [fields3,enablefields3] = useState<boolean>(true);
    const [error, setError] = useState<LocationError>({ showError: false });
    //const [fieldlabel1,setLabel1] = useState<string>('Save');
    //const [fieldlabel2,setLabel2] = useState<string>('Save');
    //const [fieldlabel3,setLabel3] = useState<string>('Save');
    function logOut(){
      console.log("logout");
      remove('cred');
      history.push('/home');
    }

    function deleteProject(){
      console.log("alert");
    }
    function activateProjects(project:string,title:string){
      if(project === 'project1'){
        if(fields1 === true){
          enablefields1(false);

        }else{
          enablefields1(true);
          //remove data 
          remove('project1');
          //also remove the field info and the associated markers
          var deletetitle = title.replace(/ /g,"_");
          remove(deletetitle);
          setproj1name("");
        }
      }else if(project === 'project2'){
        if(fields2 === true){
          enablefields2(false);
        }else{
          enablefields2(true);
          remove('project2');

          //also remove the field info and the associated markers
          var deletetitle = title.replace(/ /g,"_");
          remove(deletetitle);
          setproj2name("");
          handleSlidesMove(1);
        }
      }else if(project === 'project3'){
        if(fields3 === true){
          enablefields3(false);
        }else{
          enablefields3(true);
          remove('project3');

          //also remove the field info and the associated markers
          var deletetitle = title.replace(/ /g,"_");
          remove(deletetitle);
          setproj3name("");
          handleSlidesMove(1);
        }
      }
    }
    //save project to storage - or continue to next page if stored. 
    function saveProject(x:number, name:string, description:string, color:string){
      if(name !== ""){
        saveToStorage('project'+x,name,description,color);
      }else{
        setError({ showError: true, message: "You must choose a name for your project" });
      }
        //go to the next page to add markers. 
        //history.push('/editmarkers/group'+ x + '/' + color + '/' + name);
      
    }
    function openProject(x:number, name:string, color:string){
      if(name === ""){
        setError({ showError: true, message: "You must choose a title for your project" });
      }else{
        history.push('/editmarkers/group'+ x + '/' + color + '/' + name);
      }
    }
    function toggleProjects(){
      if(project1 === ""){
        setproj1name("Project 1");
        handleSlidesMove(0);
      }else if(project2 === ""){
        setproj2name("Project 2");
        handleSlidesMove(1);
      }else if(project3 === ""){
        setproj3name("Project 3");
        handleSlidesMove(2);
      }
      console.log("projects");
    }
    const mySlides = useRef(null);
    const slideOpts = {
        initialSlide: 0,
        speed: 300,
        grabCursor: false,
        allowTouchMove: false,
    };
    const getIndex = async (event: any) => {
      let index: number = 0;
      await event.target.getActiveIndex().then((value: any) => (index=value));
      //setCurrent(index);
      //scroll to top
      document?.querySelector("ion-content")?.scrollToTop(500); 
    }
    
    //swiper
    const init = async function(this: any) {
        setSwiper(await this.getSwiper());
        //setCurrent(0);
    };
    const handleSlidesMove = (e:any) =>{ 
      swiper.slideTo(e); 
    }
    return (
      <>
      <IonToast
      isOpen={error.showError}
      onDidDismiss={() => setError({ message: "", showError: false })}
      message={error.message}
      position={'middle'}
      duration={3000}/>
      <IonPage>
        <LoginCheck/>
        <IonHeader translucent={true} >
        <IonToolbar>
        <IonButton size="small" slot="start" color="primary" onClick={() => history.push("/explore")} className="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
        <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  className="logout"><IonIcon slot="end" icon={logOutOutline}/>Log Out</IonButton>
        </IonToolbar>

      
      </IonHeader>
            <IonContent className="ion-text-center maintext headerimage">
            <IonText className="plantext innertext">
      <span>[</span>  <h3>Explore</h3> <span>]</span><h5>Edit Explorations</h5></IonText>
      <IonText className="browntext">Enter a title and description for your exploration and choose a marker color. Save. Then choose "Open" to add a location markers to your map.</IonText>
      
      <IonSlides 
      className="explore-section"
      pager={false} 
      onIonSlidesDidLoad={init}
      options={slideOpts} 
      ref={mySlides}>
      <IonSlide className="slide">
        <IonGrid>
          <IonRow><strong className="sectiontitle">{project1}</strong></IonRow>
        <IonCol>
          <IonRow><IonItem>
            <IonLabel position="stacked">Project Title</IonLabel>
            <IonInput 
              value={project1} 
              disabled={fields1}
              onIonChange={(e) => setproj1name(e.detail.value!)}
            ></IonInput></IonItem>
            <IonItem>
           <IonLabel position="stacked">Color</IonLabel>
            <IonSelect value={color1} placeholder="Select One" onIonChange={e => setproj1color(e.detail.value!)}
            disabled={fields1}
            >
              <IonSelectOption value="blue">Blue</IonSelectOption>
              <IonSelectOption value="green">Green</IonSelectOption>
              <IonSelectOption value="orange">Orange</IonSelectOption>
            </IonSelect>
          </IonItem>
            </IonRow>
            </IonCol>
           <IonRow><IonItem className="full">
             <IonLabel position="stacked">Project Description</IonLabel>
             <IonTextarea 
              value={description1}
              disabled={fields1}
              onIonChange={(e) => setdesc1(e.detail.value!)}
              ></IonTextarea></IonItem></IonRow>
          <IonRow><IonButton onClick={()=> saveProject(1,project1,description1,color1)} disabled={fields1}>Save</IonButton>
          <IonButton onClick={()=> openProject(1,project1,color1)} disabled={fields1}>Open</IonButton>
          <IonButton onClick={()=>activateProjects('project1',project1)} >
          {(function() {
              if(fields1){
                return(
                  <IonIcon icon={openOutline}/>
                );
              }else{
                return(
                  <IonIcon icon={trashOutline}/>
                );
              }
          })()}
          </IonButton>
          </IonRow>
          </IonGrid>
      </IonSlide>
      <IonSlide className="slide">
        
        <IonGrid>
        <IonRow>
        <strong className="sectiontitle">{project2}</strong>
        </IonRow>
        <IonCol>
          <IonRow><IonItem><IonLabel position="stacked">Project Title</IonLabel>
          <IonInput value={project2} 
          disabled={fields2} 
          onIonChange={(e) => setproj2name(e.detail.value!)}>
          </IonInput></IonItem>
          <IonItem>
           <IonLabel position="stacked">Color</IonLabel>
            <IonSelect value={color2} placeholder="Select One" onIonChange={e => setproj2color(e.detail.value)} disabled={fields2}>
              <IonSelectOption value="blue">Blue</IonSelectOption>
              <IonSelectOption value="green">Green</IonSelectOption>
              <IonSelectOption value="orange">Orange</IonSelectOption>
            </IonSelect>
          </IonItem>
          </IonRow>
          </IonCol>
          <IonRow><IonItem className="full"><IonLabel position="stacked">Project Description</IonLabel>
          <IonTextarea
          value={description2} 
          disabled={fields2} 
          onIonChange={(e) => setdesc2(e.detail.value!)}>
          </IonTextarea></IonItem>
          </IonRow>

          <IonRow>
          <IonButton onClick={()=> openProject(1,project2,color2)} disabled={fields2}>Open</IonButton>
          <IonButton disabled={fields2} onClick={()=> saveProject(2,project2,description2,color2)}>Save</IonButton>
          <IonButton onClick={()=>activateProjects('project2',project2)}>
          {(function() {
              if(fields2){
                return(
                  <IonIcon icon={openOutline}/>
                );
              }else{
                return(
                  <IonIcon icon={trashOutline}/>
                );
              }
          })()}
          </IonButton></IonRow>
          </IonGrid>
      </IonSlide>
      <IonSlide className="slide">
      
        <IonGrid>
        <IonRow>
        <strong className="sectiontitle">{project3}</strong>
        </IonRow>
        <IonCol><IonRow><IonItem><IonLabel position="stacked">Project Title</IonLabel>
        <IonInput value={project3} disabled={fields3} onIonChange={(e) => setproj3name(e.detail.value!)}>
          </IonInput></IonItem>
          <IonItem>
           <IonLabel position="stacked">Color</IonLabel>
            <IonSelect value={color3} placeholder="Select One" onIonChange={e => setproj3color(e.detail.value)} disabled={fields3}>
              <IonSelectOption value="blue">Blue</IonSelectOption>
              <IonSelectOption value="green">Green</IonSelectOption>
              <IonSelectOption value="orange">Orange</IonSelectOption>
            </IonSelect>
          </IonItem></IonRow></IonCol>
          
          <IonRow><IonItem className="full"><IonLabel position="stacked">Project Description</IonLabel>
          <IonTextarea value={description3} disabled={fields3} onIonChange={(e) => setdesc3(e.detail.value!)}>
          </IonTextarea>
          </IonItem></IonRow>
          <IonRow>
          <IonButton onClick={()=> openProject(3,project3,color3)} disabled={fields3}>Open</IonButton>
          <IonButton disabled={fields3} onClick={()=> saveProject(3,project3,description3,color3)}>Save</IonButton>
          <IonButton onClick={()=>activateProjects('project3',project3)}>
          {(function() {
              if(fields3){
                return(
                  <IonIcon icon={openOutline}/>
                );
              }else{
                return(
                  <IonIcon icon={trashOutline}/>
                );
              }
          })()}
          </IonButton></IonRow>     
          </IonGrid>
      </IonSlide>
    </IonSlides>
      <IonButtons className="centered">
        <IonButton color="primary" onClick={() => handleSlidesMove(0)}>{project1}</IonButton>
        {(function() {
              if(project2 !== ""){
                return(
                  <IonButton color="primary" onClick={() => handleSlidesMove(1)}>{project2}</IonButton>
                )
              }
        })()}
        
        {(function() {
              if(project3 !== ""){
                return(
                  <IonButton color="primary" onClick={() => handleSlidesMove(2)}>{project3}</IonButton>
                )
              }
        })()}
        
        {(function() {
              if(project1 !== "" && (project2 === "" || project3 === "") || (project1 === "" && project2 !== "" && project3 !== "") || (project1 === "" && project2 !== "" && project3 === "")){
                return(
                  <IonButton color="primary" onClick={() => toggleProjects()}>Add</IonButton>
                )
              }
        })()}
      </IonButtons>
      
   
        </IonContent>
      
        <FooterComponent/>
      </IonPage>
      </>
    );
  };

export default CreateExploration;